export const compareByName = (a, b) =>
  String(a ?? '').localeCompare(String(b ?? ''), undefined, { sensitivity: 'base' })

export const sortByLabel = (options) => [...options].sort((a, b) => compareByName(a.label, b.label))

export const sortCustomersByName = (customers) =>
  [...customers].sort((a, b) => compareByName(a.customer_name, b.customer_name))

/** Pure A–Z select options from customer entities */
export const toCustomerSelectOptions = (customers, mapExtra) =>
  sortByLabel(
    (customers ?? []).map((c) => ({
      value: c.id,
      label: c.customer_name,
      ...(typeof mapExtra === 'function' ? mapExtra(c) : {}),
    })),
  )

/**
 * Parent MSP first (no parent_id), then A–Z by label within each group.
 * mapExtra can add fields like isDisabled.
 */
export const toCustomerSelectOptionsParentFirst = (customers, mapExtra) =>
  [...(customers ?? [])]
    .map((c) => ({
      value: c.id,
      label: c.customer_name,
      isParent: !c.parent_id ? 1 : 0,
      ...(typeof mapExtra === 'function' ? mapExtra(c) : {}),
    }))
    .sort((a, b) => {
      if (a.isParent !== b.isParent) return b.isParent - a.isParent
      return compareByName(a.label, b.label)
    })

/** Sort customer entities parent-first then by customer_name (for CompanySelector which uses raw entities) */
export const sortCustomersParentFirst = (customers) =>
  [...(customers ?? [])].sort((a, b) => {
    const aParent = !a.parent_id
    const bParent = !b.parent_id
    if (aParent !== bParent) return aParent ? -1 : 1
    return compareByName(a.customer_name, b.customer_name)
  })
